import { MallAxiosInterceptor } from "api/core/consts";

export const element = {
  searchMallElement: (paging, body) => MallAxiosInterceptor.post('mallElement/search' + paging, body),
  createMallElement: (body) => MallAxiosInterceptor.post('mallElement', body),
  uploadMallElements: (body) => MallAxiosInterceptor.post('mallElements', body),
  updateMallElement: (mallElementId, body) => MallAxiosInterceptor.put('mallElement/' + mallElementId, body),
  deleteMallElement: (mallElementId) => MallAxiosInterceptor.delete('mallElement/' + mallElementId),
};
